document.addEventListener('DOMContentLoaded', function () {
  const FREE_TRIAL_VARIANT_ID = 45926315327545;
  const MESSAGE_TEXT = 'You have already added your free trial. Only one free trial is allowed per order.';

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  function showPermanentMessage(button) {
    let msg = document.querySelector('.free-trial-permanent-message');

    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'free-trial-permanent-message';
      msg.textContent = MESSAGE_TEXT;

      button.closest('add-to-cart-component').appendChild(msg);
    }

    msg.style.display = 'block';
  }

    async function disableTrialButtonIfAdded() {
    const cart = await getCart();
    const alreadyAdded = cart.items.some(item => item.variant_id === FREE_TRIAL_VARIANT_ID);

    const trialForms = document.querySelectorAll(`form input[name="id"][value="${FREE_TRIAL_VARIANT_ID}"]`);

    trialForms.forEach(input => {
        const form = input.closest('form');
        const button = form?.querySelector('button[type="submit"][name="add"]');
        if (!button) return;

        let msg = form.querySelector('.free-trial-permanent-message');
        const text = button.querySelector('.add-to-cart-text__content span span');

        if (alreadyAdded) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('free-trial-disabled');

        if (text) text.textContent = 'Already added';

        if (!msg) {
            msg = document.createElement('div');
            msg.className = 'free-trial-permanent-message';
            msg.textContent = MESSAGE_TEXT;
            button.closest('add-to-cart-component')?.appendChild(msg);
        }

        msg.style.display = 'block';
        } else {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('free-trial-disabled');

        if (text) text.textContent = button.classList.contains('quick-add__button') ? 'Add' : 'Add to cart';

        if (msg) msg.style.display = 'none';
        }
    });
    }

  disableTrialButtonIfAdded();

  document.addEventListener('cart:update', disableTrialButtonIfAdded);
  document.addEventListener('cart:refresh', disableTrialButtonIfAdded);

  setInterval(disableTrialButtonIfAdded, 1500);
  
  document.addEventListener('click', function () {
  setTimeout(disableTrialButtonIfAdded, 800);
  setTimeout(disableTrialButtonIfAdded, 1500);
});
});
